import { useState } from 'react';
import { useAxios } from '../../utils/hook/useAxios';
function AdminLogin() {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const axios = useAxios();
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  function handleConnecter() {
    let fetchConnect = async () => {
      const response = await axios.post('/auth/admin/login', {
        email: email,
        password: password,
      });
      if (response) {
        window.location.href = '/admin/users';
      }
    };
    fetchConnect();
  }
  return (
    <section className="mb-3">
      <div className="container">
        <div className="row d-flex align-items-center my-2 my-md-5">
          {' '}
          <div className="col-11 col-lg-8 pt-3 mx-auto text-center">
            <h2>Connectez-vous à l'espace admin</h2>
          </div>
          <form action="" className="col-11 col-lg-8 py-4 px-lg-6 mx-auto">
            <div className="col-12 col-md-6 mx-auto">
              <div class="input-group">
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  aria-describedby="emailHelp"
                  title="Adresse email"
                  placeholder="Adresse email"
                  value={email}
                  onChange={handleEmailChange}
                />
                <span class="input-group-text bg-primary text-white border-primary">
                  <ion-icon name="mail-outline"></ion-icon>
                </span>
              </div>
              <div class="input-group mt-2">
                <input
                  type="password"
                  class="form-control"
                  name="password"
                  aria-describedby="passwordHelp"
                  title="Mot de passe"
                  placeholder="Mot de passe"
                  value={password}
                  onChange={handlePasswordChange}
                />
                <span class="input-group-text bg-primary text-white border-primary">
                  <ion-icon name="key-outline"></ion-icon>
                </span>
              </div>
            </div>
          </form>
          <div class="col-11 col-lg-8 py-4 px-lg-6 mx-auto">
            <div className="col-12 col-md-6 d-flex flex-column mx-auto gap-2">
              <button
                type="button"
                class="btn-block btn btn-primary text-white"
                id="userbutton"
                onClick={handleConnecter}
              >
                Se connecter
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminLogin;
